export default __webpack_public_path__ + "static/media/DonationPic.80c26a47.jpg";